var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking-expired-countdown"},[_c('span',{staticClass:"booking-expired-countdown__text"},[_vm._v(" "+_vm._s(_vm.$t("Time left for pay"))+": ")]),_c('span',{staticClass:"booking-expired-countdown__timer"},[_vm._v(" "+_vm._s(_vm.expiredCountdown.minutes)+":"+_vm._s(_vm.getSeconds(_vm.expiredCountdown.seconds))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }